module.exports = __webpack_public_path__ + "static/img/sms.08bcd895.png";